<template>
  <v-app>
    <v-navigation-drawer v-model="controls.drawer" width="322px" floating app>
      <v-layout
        align-center
        justify-center
        column
        class="app-logo-container"
        style="height: 322px"
      >
        <div class="app-logo-sheet">
          <v-img
            :src="require('@/assets/images/logo.png')"
            width="78px"
            height="74px"
            class="ma-6"
          ></v-img>
        </div>
        <div class="app-company--name mt-8">My Training Space</div>
        <div class="app-project--name mt-2">Admin CMS</div>
      </v-layout>

      <v-list class="app-nav" flat>
        <v-subheader class="mb-5">
          <div class="app-nav--title mx-auto">NAVIGATION</div>
        </v-subheader>
        <div v-for="item in navItems" :key="item.label">
          <v-list-item
            v-if="!item.items"
            link
            active-class="white black--text"
            :to="item.to"
          >
            <v-list-item-content>
              <v-list-item-title class="pa-2 app-nav--item">{{
                item.label
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group v-else no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  class="pa-2 app-nav--item"
                  v-text="item.label"
                ></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              link
              v-for="child in item.items"
              :key="child.title"
              :to="child.to"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="pa-2 app-nav--item"
                  v-text="child.label"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>

      <template v-slot:append>
        <v-list>
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-list-item two-line v-on="on">
                <v-list-item-avatar>
                  <user-avatar size="40" :avatar="user.avatar" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ user.email ? user.email : user.phone_number }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item
                :to="{ name: 'user.details', params: { id: user.id } }"
              >
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Settings</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logoutConfirmDialog = true">
                <v-list-item-title>Log out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-content class="main-content">
      <div class="px-xl-12 px-lg-10 px-md-6 px-sm-4 px-xs-2">
        <slot />
      </div>
    </v-content>
    <ConfirmModal
      v-model="logoutConfirmDialog"
      title="Logout"
      message="Are you sure you want to logout?"
    >
      <v-btn text @click="logoutConfirmDialog = false">Cancel</v-btn>
      <v-btn color="primary" text @click="logout">Logout</v-btn>
    </ConfirmModal>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      multi-line
      left
    >
      {{ snackbar.text }}

      <template #action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import ConfirmModal from '@/components/modals/ConfirmModal'
import { mapState, mapActions, mapGetters } from 'vuex'
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'MainLayout',

  components: {
    UserAvatar,
    ConfirmModal,
  },

  mixins: [ControlsMixin],

  data() {
    return {
      navItems: [
        // { label: 'Inbox', to: { name: 'inbox' } },
        { label: 'Users', to: { name: 'users' } },
        {
          label: 'App',
          items: [
            {
              label: 'Onboarding',
              to: { name: 'on-boarding' },
            },
          ],
        },
        {
          label: 'Transactions',
          items: [
            {
              label: 'Transactions',
              to: { name: 'transactions' },
            },
            {
              label: 'Subscriptions',
              to: { name: 'subscriptions' },
            },
          ],
        },
        {
          label: 'Exercise',
          to: { name: 'exercise' },
        },
        {
          label: 'Education',
          items: [
            {
              label: 'Education',
              to: { name: 'education' },
            },
            {
              label: 'Create Education',
              to: { name: 'education.create' },
            },
            {
              label: 'Categories',
              to: { name: 'education-categories' },
            },
          ],
        },
        {
          label: 'Program',
          to: { name: 'program' },
        },
        {
          label: 'Practitioner',
          items: [
            {
              label: 'Practitioner',
              to: { name: 'practitioner' },
            },
            {
              label: 'Create Practitioner',
              to: { name: 'practitioner.create' },
            },
          ],
        },
        // { label: 'Content', to: { name: 'content' } },
        // { label: 'Notifications', to: { name: 'notification' } },
        { label: 'Settings', to: { name: 'settings' } },
        // { label: 'Reports', to: { name: 'reports' } }
      ],
      logoutConfirmDialog: false,
    }
  },

  computed: {
    ...mapState({
      snackbar: (state) => state.snackbar,
      user: (state) => state.auth.user,
    }),
    ...mapGetters({
      avatarThumb: 'auth/avatarThumb',
    }),
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
  },
}
</script>
